import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import style from './AssignmentBtn.module.scss';

const AssignmentBtn: React.FC = () => {
	const hasAccess = useRoleAccess([UserRoles.SUPER_USER, UserRoles.TECHNICAL]);

	return (
		<Link
			className={style.container}
			to={`/entertainment/games${hasAccess ? '/games-assign' : ''}`}
			data-test="AssignmentBtn">
			<Button
				className={style.button}
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#list`} />
					</svg>
				}
				disabled={!hasAccess}>
				<Text translationNameSpace="listing" translationKey="assignToRestaurantsButton" asFragment={true} />
			</Button>
		</Link>
	);
};

export default AssignmentBtn;
